import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').DividerBlock}
 */
const Divider = () => {
    return (
        <div className='col-padding w-full sm:w-8/9 md:w-3/4'>
            <div className='h-1 w-full bg-border-default' />
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Divider;
